import {useState,useEffect,useCallback,memo,useRef} from 'react'
import {useParams} from 'react-router-dom'
import {debounce} from 'lodash'
//components
import { TextBox } from 'devextreme-react/text-box';
import {
  Validator,
  RequiredRule,
  CustomRule
} from 'devextreme-react/validator';
import GroupButton from '../button/group-button'
//utils
// import { getGeocoding } from '../../../../utils/search-properties'

//constant
import { LATITUDE_DEFAULT, LONGITUDE_DEFAULT } from '../../../../constant/default-properties'
//styles
import '../../styles/input/custom-input.css'

const InputSearch = ({label,location,onChange,placeholder,inputId,classCustom,disable,onChangeGeometry,groupButton,requiredValue,labelSize,clearField,setClearField,setIsSelected}) => {
  const params = useParams()
  const refValidator = useRef()
  const [isFocus, setisFocus] = useState()
  const [isOnEnter, setisOnEnter] = useState(false)
  const [isOnPlaceChanged, setIsOnPlaceChanged] = useState(false)
  const clearGeometry = {
    latitude: '',
    longitude: ''
  }
  const [valueSearch,setValueSearch] = useState((location?.value) ? location.value : '')
  const [placeId, setPlaceId] = useState(location ? location : '')
  let autocomplete = {}
  let autocompleteservice = {}

  const onPlaceChanged = () => { 
    setIsOnPlaceChanged(true)
    if(Object.keys(autocomplete.getPlace()).length > 1)
    {
      onChange({
        id:'',
        value:''
      })
      setValueSearch(document.querySelector(`#${inputId}`)?.value)
    }
  }
  
  const getPlaceId = (value) => {

    if (value)
      autocompleteservice.getQueryPredictions({ 'input': value }, (prediction) => {

        let place = []

        if (prediction) {
          place = prediction.filter(result => {
            return result.description.toLowerCase().trim().normalize('NFD').replace(/\p{Diacritic}/gu, "") === value.toLowerCase().trim().normalize('NFD').replace(/\p{Diacritic}/gu, "")
          })
        }
        setPlaceId({
          id: place.length === 1 ? place[0].place_id : '',
          value: value
        })
      })
    else
      setPlaceId({
        id: '',
        value: value
      })

  }
  
  const onChangeSearch = useCallback(debounce(value => {
    getPlaceId(value)
  }, 500), [])
  const onEnterChange = useCallback(e=>{
    if(e.key === 'Enter')
      setisOnEnter(true)
    else
    {
      setisOnEnter(false)
      setIsOnPlaceChanged(false)
    }
  },[])
  useEffect(() => {
      autocomplete = {}
      autocompleteservice={}
      autocomplete = new window.google.maps.places.Autocomplete(document.querySelector(`#${inputId}`))
      autocompleteservice = new window.google.maps.places.AutocompleteService()     
      autocomplete.addListener('place_changed', onPlaceChanged) 
      window.addEventListener('keydown', onEnterChange)
      return () => {
        window.removeEventListener('keydown', onEnterChange)
      }
  }, [])
  
  useEffect(() => {

    if(!clearField)
    {
      if(!valueSearch)
      {
          onChange({
            id:'',
            value:''
          })

          onChangeGeometry && onChangeGeometry(clearGeometry)
      }
      onChangeSearch(valueSearch)
    }
  }, [valueSearch])  
  
  useEffect(() => {
    onChange({
      id: placeId.id,
      value: placeId.value
    })
    // onChangeGeometry && placeId.id && getGeocoding(placeId.id)
    onChangeGeometry && !placeId.id && placeId.value && onChangeGeometry('error')
  }, [placeId])

  useEffect(() => {
    params.address && setValueSearch(params.address)
    params.id && params.address && setPlaceId({
      id: params.id,
      value: params.value
    })
    if(!params.address)
      onChangeGeometry && onChangeGeometry({
        latitude: LATITUDE_DEFAULT,
        longitude: LONGITUDE_DEFAULT
      })
  }, [params])

  const getValidPlaceId = e => {
    return !isFocus ? placeId.id : true
  }
  useEffect(() => {
    if(clearField)
    {
      setValueSearch('') 
      refValidator?.current?.instance?.option('isValid') === false && refValidator?.current?.instance?.reset() 
    }
  }, [clearField,location])
 
  const onValidated = useCallback(e => {
    if(clearField && !valueSearch)
    {
      refValidator?.current?.instance?.option('isValid') === false && refValidator?.current?.instance?.reset()
      setClearField(false)
    }
      let inputHeight = document.querySelector(`#${inputId}`).offsetHeight
      let validationPosition = inputHeight + 35
      let overlay = e.element?.querySelector(".dx-invalid-message-content")
      if(overlay)
        overlay.style.top=`-${validationPosition}px`
  },[clearField,valueSearch])
  const onKeyValidation = useCallback(e=>{
    let regex = /[<>]/
    regex.test(e.event.key) && e.event.preventDefault()
  },[])
  useEffect(() => {
    if(location?.value)
      setValueSearch(location.value)
  }, [location])

useEffect(() => {
  if(setIsSelected)
  {
    if(location?.id && isOnEnter && isOnPlaceChanged)
    {
       setIsSelected(true)
    }
    else  
      setIsSelected(false)
  }
}, [isOnEnter,location,isOnPlaceChanged])
  useEffect(() => {
    if(!isFocus)
    {
      setIsOnPlaceChanged(false)
      setisOnEnter(false)
    }
  }, [isFocus])
  
  return (
    <>
      {label ? 
        <div className='custom-input' style={labelSize ? {gridTemplateColumns: `${labelSize} calc(100% - ${labelSize} - 20px)`} : {}}>
            <div className='custom-input__label'>{label}:{requiredValue ? <span>*</span> : ''}</div>
              <div className={`custom-input__group-button ${groupButton.direction==='left' ? 'custom-input__group-button--left': 'custom-input__group-button--right'}`}>
                {groupButton && <GroupButton direction={groupButton.direction} action={groupButton.action}>{groupButton.name}</GroupButton>}
                <div className='custom-input__container'>
                <TextBox
                  inputAttr={{
                    id: inputId
                  }}
                  className={classCustom}
                  disabled={disable}
                  placeholder={placeholder}
                  value={valueSearch}
                  valueChangeEvent="input"
                  onValueChange={data=>setValueSearch(data)}
                  onKeyDown={onKeyValidation}
                >
                  {requiredValue &&
                    <Validator 
                      ref={refValidator}
                      onValidated={onValidated}
                    >
                      <RequiredRule message={`${label} is required`} />
                      <CustomRule
                              validationCallback={getValidPlaceId}
                              message={`${label} is not valid`}
                          />
                    </Validator>
                  }
                </TextBox>
                </div>
            </div>
          </div>
        :
        <div className='custom-input__group-button'>
          {groupButton && <GroupButton direction={groupButton.direction} action={groupButton.action}>{groupButton.name}</GroupButton>}
          <div className='custom-input__container'>
            <TextBox
              inputAttr={{
                id: inputId
              }}
              className={classCustom}
              disabled={disable}
              placeholder={placeholder}
              value={valueSearch}
              valueChangeEvent="input"
              onValueChange={data => setValueSearch(data)}
              onFocusIn={_=>setisFocus(true)}
              onFocusOut={_=>setisFocus(false)}
              validationMessageMode='always'
            >
              {requiredValue &&
                <Validator
                  onValidated={onValidated}
                >
                  <RequiredRule message={`${placeholder ? placeholder : 'Location'} is required`} />
                  <CustomRule
                    validationCallback={getValidPlaceId}
                    message={`${placeholder ? placeholder : 'Location'} is not valid`}
                  />
                </Validator>
              }
            </TextBox>
          </div>
        </div>
      }
    </>

  )
}

export default InputSearch